export const blockIconsContentBackspace = (
	<span className='material-symbols-outlined'>backspace</span>
);
